import { render, staticRenderFns } from "./applicants-page.vue?vue&type=template&id=5ef38a0e&scoped=true"
import script from "./applicants-page.vue?vue&type=script&lang=ts"
export * from "./applicants-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef38a0e",
  null
  
)

export default component.exports